/* eslint-disable id-blacklist, func-style */

export function addEvent(object, type, callback) {
  if (object === null || typeof (object) === 'undefined') {
    return;
  }
  if (object.addEventListener) {
    object.addEventListener(type, callback, false);
  } else if (object.attachEvent) {
    object.attachEvent(`on${ type }`, callback);
  } else {
    object[`on${ type }`] = callback;
  }
}

export function removeEvent(object, type, callback) {
  if (object === null || typeof (object) === 'undefined') {
    return;
  }
  if (object.removeEventListener) {
    object.removeEventListener(type, callback, false);
  } else if (object.removeEvent) {
    object.removeEvent(`on${ type }`);
  }
}

export function triggerEvent(element, eventName, options) {
  let event = null;
  if (window.CustomEvent) {
    event = new CustomEvent(eventName, options);
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, options);
  }
  element.dispatchEvent(event);
}

export function cancelBubble(event) {
  const evt = event ? event : window.event;
  if (evt.stopPropagation) {
    evt.stopPropagation();
  }
  if (evt.cancelBubble !== null) {
    evt.cancelBubble = true;
  }
}

/* eslint-disable prefer-reflect */
export function Throttle(functionToCall, throttleTime) {
  let wait = false;
  const trigger = (context) => {
    if (!wait) {
      wait = true;
      setTimeout(() => {
        if (functionToCall) {
          functionToCall.call(context);
        }
        wait = false;
      }, throttleTime);
    }
  };
  return {
    trigger,
  };
}
/* eslint-enable prefer-reflect */



// WEBPACK FOOTER //
// ./js/utils/events.js